import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UPDATE_PERSONAL_STYLES, UPDATE_BROKERAGE_STYLES, UPDATE_NAV_LOGO } from "../../store/settings-actions";
import { SET_THEME_PREVIEW } from "../../store/settings-mutations";
import { SET_STYLES } from "@Broker/@Modules/main/store/account/account-mutations";
import { LOAD_STYLES } from "@Broker/@Modules/main/store/account/account-actions";
import FixedBanner from "@Shared/components/general/fixed-banner";
import { mapActions, mapState, mapMutations } from "vuex";
import { getCurrentStyles } from "@Broker/js/custom/utils";
import { updateColours } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PreviewThemeBanner",
  components: {
    FixedBanner
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["overrides", "previewModeSource", "brokerageData"])), mapState("AccountStore", ["accountDetails", "styles"])), {}, {
    brokerageSubdomain() {
      return this.brokerageData.subdomain;
    },
    personalSubdomain() {
      return this.accountDetails.accountSubdomain;
    },
    subdomainToUse() {
      return this.isBrokerageSettings ? this.brokerageSubdomain : this.personalSubdomain;
    },
    currentPrimary() {
      return this.styles.primary || "";
    },
    currentSecondary() {
      return this.styles.secondary || "";
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_PERSONAL_STYLES, UPDATE_BROKERAGE_STYLES, UPDATE_NAV_LOGO])), mapActions("AccountStore", [LOAD_STYLES])), mapMutations("SettingsStore", [SET_THEME_PREVIEW])), mapMutations("AccountStore", [SET_STYLES])), {}, {
    revertStyles() {
      updateColours(this.styles.primary, this.styles.secondary);
    },
    async savePersonalTheme() {
      const file = getCurrentStyles();
      const override = this.overrides.overrideStyle;
      await this.UPDATE_PERSONAL_STYLES({
        file
      });
      if (override === false) this.LOAD_STYLES();
      this.$emit("finish-saving", true);
      this.$emit("form-change", false);
      this.formChanged = false;
    },
    async saveBrokerageTheme() {
      const file = getCurrentStyles();
      const override = this.overrides.overrideStyle;
      await this.UPDATE_BROKERAGE_STYLES({
        file
      });
      if (override) this.LOAD_STYLES();
    },
    async saveTheme() {
      if (this.previewModeSource === "brokerage-settings") {
        await this.saveBrokerageTheme();
      } else {
        await this.savePersonalTheme();
        return;
      }
      if (!this.overrides.overrideLogo) {
        this.UPDATE_NAV_LOGO({
          domain: this.subdomainToUse
        });
      }
      this.revertStyles();
      this.$emit("load-styles");
      this.$emit("finish-saving", true);
    },
    handleSaveTheme() {
      this.saveTheme();
      this.SET_THEME_PREVIEW({
        previewMode: false
      });
    },
    handleToggleOffPreview() {
      this.revertStyles();
      this.SET_THEME_PREVIEW({
        previewMode: false
      });
    }
  })
});